import VetConfirmation from "./VetConfirmation";
export default VetConfirmation;
